import { render, staticRenderFns } from "./LinkQuestion.vue?vue&type=template&id=712eae2a&"
import script from "./LinkQuestion.vue?vue&type=script&lang=js&"
export * from "./LinkQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('712eae2a')) {
      api.createRecord('712eae2a', component.options)
    } else {
      api.reload('712eae2a', component.options)
    }
    module.hot.accept("./LinkQuestion.vue?vue&type=template&id=712eae2a&", function () {
      api.rerender('712eae2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/LinkQuestion.vue"
export default component.exports